import { type ReactNode } from 'react';

import { MultiMeterBarChartOverlay } from './MultiMeterBarChartOverlay/MultiMeterBarChartOverlay.js';
import { MultiMeterBarChartSegments } from './MultiMeterBarChartSegments.js';
import { MeterBarPlot } from '../../shared/components/meter-bar-plot/MeterBarPlot.js';
import { MultiMeterBarChartTooltipProvider } from '../context/MultiMeterBarChartTooltipContext.js';
import type { MultiMeterBarChartInternalTooltipConfig } from '../types/multi-meter-bar-chart-internal.js';

export interface MultiMeterBarChartPlotAreaProps {
  label: ReactNode;
  max: number;
  min: number;
  tooltipConfig: MultiMeterBarChartInternalTooltipConfig;
  width: number;
}

export const MultiMeterBarChartPlotArea = ({
  label,
  max,
  min,
  tooltipConfig,
  width,
}: MultiMeterBarChartPlotAreaProps) => (
  <MultiMeterBarChartTooltipProvider data={{ tooltipConfig, label }}>
    <MultiMeterBarChartOverlay>
      <MeterBarPlot>
        <MultiMeterBarChartSegments max={max} min={min} width={width} />
      </MeterBarPlot>
    </MultiMeterBarChartOverlay>
  </MultiMeterBarChartTooltipProvider>
);
